import { Timeline } from 'antd';
import styled from 'styled-components';

export default styled(Timeline)`
	// Add your styles here
`;
